import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { forwardRef, useImperativeHandle } from "react"

const ReadBAAModal = forwardRef(({
  title,
  message,
  onClose,
  handleDelete,
}, ref) => {

  useImperativeHandle(ref, () => ({
    handleDelete
  }))

  return (
    <Dialog width={'70%'} height={'70%'} style={{overflowY: 'scroll'}} onClose={onClose} title={title}>
      <p
        style={{
          margin: "25px",
          textAlign: "center",
        }}
        dangerouslySetInnerHTML={{
            __html: message
        }}
      />
      {<DialogActionsBar>

      </DialogActionsBar>}
    </Dialog>
  )
})

export default ReadBAAModal